import styled from 'styled-components'

import { DomUtil } from '@root/shared'

import {
  BUY_COLOR,
  LABEL_HEIGHT,
  POINT_OUTER_SIZE,
  SELL_COLOR,
} from './constants'
import { TradePositionChartPoint } from './trade-position-chart-point'

import type { ChartEntry } from './use-chart-data'

const CONNECTOR_MAX_HEIGHT = 26

type TradePositionChartPointProps = {
  entry: ChartEntry

  barOriginY: number
  barCenterX: number
}

export const TradePositionChartSwaps: React.FC<
  TradePositionChartPointProps
> = ({ entry, barOriginY, barCenterX }) => {
  const elements = []

  if (!entry.buys && !entry.sells) {
    return undefined
  }

  let originY = barOriginY - 2

  if (entry.sells > 0) {
    originY = originY - POINT_OUTER_SIZE
    elements.push(
      <TradePositionChartPoint type="sell" x={barCenterX} y={originY} />,
    )
  }

  if (entry.buys > 0) {
    if (entry.sells > 0) {
      originY = originY - 2
    }
    originY = originY - POINT_OUTER_SIZE
    elements.push(
      <TradePositionChartPoint type="buy" x={barCenterX} y={originY} />,
    )
  }

  const availableHeight =
    originY -
    (entry.buys ? LABEL_HEIGHT : 0) -
    (entry.sells ? LABEL_HEIGHT : 0) -
    (entry.buys && entry.sells ? 1 : 0)

  const connectorHeight = Math.min(CONNECTOR_MAX_HEIGHT, availableHeight)

  originY = originY - connectorHeight

  elements.push(
    <rect
      x={barCenterX - 0.5}
      y={originY}
      opacity="0.35"
      width="1"
      height={connectorHeight}
      rx="0.5"
      fill={DomUtil.svgUrl('chart-line-gradient')}
    />,
  )

  // Labels

  if (entry.sells > 0) {
    originY = originY - LABEL_HEIGHT
    elements.push(
      <>
        {/* <rect
          fill="red"
          opacity={0.4}
          x={barCenterX}
          width={4}
          height={LABEL_HEIGHT}
          y={originY}
        /> */}
        <Label
          textAnchor="middle"
          alignmentBaseline="central"
          x={barCenterX}
          y={originY + LABEL_HEIGHT / 2}
          fill={SELL_COLOR}
        >
          {entry.sells}
        </Label>
      </>,
    )
  }

  const shouldRenderDelimiter = entry.sells && entry.buys

  if (shouldRenderDelimiter) {
    originY = originY - 1

    elements.push(
      <rect
        x={barCenterX - 2}
        y={originY}
        rx={1}
        width={4}
        height={1}
        fill="#d9d9d9"
        opacity={0.17}
      />,
    )
  }

  if (entry.buys > 0) {
    originY = originY - LABEL_HEIGHT
    elements.push(
      <>
        {/* <rect
          fill="red"
          opacity={0.4}
          x={barCenterX}
          width={4}
          height={LABEL_HEIGHT}
          y={originY}
        /> */}
        <Label
          textAnchor="middle"
          alignmentBaseline="central"
          x={barCenterX}
          y={originY + LABEL_HEIGHT / 2}
          fill={BUY_COLOR}
        >
          {entry.buys}
        </Label>
      </>,
    )
  }

  return <g>{elements}</g>
}

const Label = styled.text`
  font-family: Inter;
  font-size: 8px;
  font-style: normal;
  font-weight: 500;
  line-height: 8px;
  text-align: center;
`
